import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';

interface ListItemProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

export default function ListItem({ children, icon, className }: ListItemProps) {
  const tef = useTEF();

  if (icon) {
    return (
      <li className={cn('flex items-start gap-2', 'list-none', tef.colors.foreground, className)}>
        <span className="flex-shrink-0 mt-0.5">{icon}</span>
        <span>{children}</span>
      </li>
    );
  }

  return <li className={cn(tef.colors.foreground, className)}>{children}</li>;
}

export { ListItem };
